import React from "react";

export default function Badge({ variant = "neutral", children }) {
  return <span className={`badge badge--${variant}`}>{children}</span>;
}
